// extracted by mini-css-extract-plugin
export default {"primaryColor":"#354760","white":"#fff","form":"styles_form__FKr-5","submit":"styles_submit__pQzol"};